
const $ = jQuery.noConflict();

'use strict';
const FormLabel = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea'),
	$domCF7: $('.wpcf7-form'),
	slWrapperInput: '.contact-from__input',
	slInputLabel: '.contact-from__input-label',
	slInputControl: '.wpcf7-form-control',
	classMoved: 'is-moved',

	/** @description Initialize */
	init: function() {
		this.formMove();
		this.formAutofill();
		this.errorScrollTo();
		// this.requiredHowManyPeople();
	},

	/** @description Bind Events */
	formMove: function() {
		this.$domInputTextarea.each(function() {
			if ($(this).val().length !== 0) { //In case there is a preloaded value
				FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
			} else {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
		});

		this.$domCF7.on('focus', '.select2-selection, input, textarea', function() { //On focus move the label
			FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
		});
		this.$domCF7.on('blur', '.select2-selection, input, textarea', function() {
			if ($(this).val().length === 0 && !$(this).find('.select2-selection__rendered').attr('title')) {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
		});
	},

	getInputLabel: function(selector) {
		return $(selector).parents(this.slWrapperInput).find(this.slInputLabel);
	},

	formAutofill: function() {
		FormLabel.$domInputTextarea.attr('autocomplete', 'negative');
	},

	errorScrollTo: function() {
		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({
					scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 180,
				}, 500, 'swing');
			}, 100);
		}, false);
	},
};

export default FormLabel;
